module.exports = __webpack_public_path__ + "static/media/tengwowwechat@2x.4e01a390.png";